import Vue from 'vue'
import Router from 'vue-router'
import Cookies from 'js-cookie'
import config from '@/config/config'
import store from '@/store/store'
import { cloneDeep, omit } from 'lodash'

import { checkToken } from '@/api/user'
import { getV4Token } from '@/apiv4/user'
import { login } from '@/utils/login'
import { registerWxConfig, setWxShare } from '@/utils/share'
import browserCheck from '@/utils/checkBrowser'
import { sendAccessLog } from '@/api/trace'
import * as bridgeHelper from '@/utils/bridge-helper'
import { getCaller } from '@/utils/app-helper'

Vue.use(Router)

let eventRoutes = [
  {
    path: '/event/red-envelope-2020',
    name: 'event/redEnvelope2020',
    component: () => import('@/views/events/red-envelope-2020'),
    meta: { title: '大年三十袋迪发红包', requireAuth: true }
  },
  {
    path: '/activity-dispense',
    name: 'activityDispense',
    component: () => import('@/views/activityDispense/index'),
    meta: { title: '口袋故事', requireAuth: true }
  }
]

const router = new Router({
  mode: 'history',
  // base: './',
  base: config.env == 'local' ? '/' : '/ilisten-h5',
  routes: [
    {
      path: '',
      redirect: 'buyvip',
      meta: {}
    },
    {
      path: '/orderdispenser',
      name: 'orderdispenser',
      component: () => import('@/views/redirect/orderDispenser'),
      meta: { title: '他人代付' }
    },
    {
      path: '/buyvip',
      name: 'buyvip',
      component: () => import('@/views/buyvip/index'),
      meta: { title: '开通VIP' }
    },
    {
      path: '/retailvip',
      name: 'retailvip',
      component: () => import('@/views/buyvip/retail'),
      meta: { title: '开通VIP' }
    },
    {
      path: '/mine',
      name: 'mine',
      component: () => import('@/views/mine/index'),
      meta: { title: '我的', requireAuth: true }
    },
    {
      path: '/order',
      name: 'order',
      component: () => import('@/views/order/index'),
      meta: { title: '确认订单', requireAuth: true }
    },
    {
      path: '/orderlist',
      name: 'orderlist',
      component: () => import('@/views/orderList/index'),
      meta: { title: '我的订单', requireAuth: true }
    },
    {
      path: '/cdkey',
      name: 'cdkey',
      component: () => import('@/views/cdkey/index'),
      meta: { title: '兑换码' }
    },
    {
      path: '/payresult',
      name: 'payresult',
      component: () => import('@/views/payResult/payResult'),
      meta: { title: '支付结果', requireAuth: true }
    },
    {
      path: '/thirdpayresult',
      name: 'thirdpayresult',
      component: () => import('@/views/payResult/thirdPayResult'),
      meta: { title: '支付结果' }
    },
    {
      path: '/helpcenter',
      name: 'helpcenter',
      component: () => import('@/views/helpCenter/index'),
      meta: { title: '投诉建议' }
    },
    {
      path: '/helppage',
      name: 'helppage',
      component: () => import('@/views/helpCenter/page'),
      meta: { title: '帮助中心' }
    },
    {
      path: '/helpsearch',
      name: 'helpsearch',
      component: () => import('@/views/helpCenter/search'),
      meta: { title: '帮助中心' }
    },
    {
      path: '/helpdetail',
      name: 'helpdetail',
      component: () => import('@/views/helpCenter/detail'),
      meta: { title: '解决方案' }
    },
    {
      path: '/couponsgoods',
      name: 'couponsgoods',
      component: () => import('@/views/coupons/goods'),
      meta: { title: '商品页', requireAuth: true }
    },
    {
      path: '/vip',
      name: 'vip',
      component: () => import('@/views/vip/index'),
      meta: { title: '口袋故事会员', desc: '客户端内可运营的VIP页' }
    },
    {
      path: '/getvip',
      name: 'getvip',
      component: () => import('@/views/vip/get'),
      meta: { title: '口袋故事', desc: '客户端内领取VIP', requireAuth: true }
    },
    {
      path: '/viprights',
      name: 'viprights',
      component: () => import('@/views/vip/rights'),
      meta: { title: '口袋故事会员', desc: '会员权益' }
    },
    {
      path: '/spirit',
      name: 'spirit',
      component: () => import('@/views/spirit/index'),
      meta: { title: '口袋精灵' }
    },
    {
      path: '/myspirit',
      name: 'myspirit',
      component: () => import('@/views/spirit/mySpirit'),
      meta: { title: '我的口袋精灵', requireAuth: true }
    },
    {
      path: '/spiritcodebind',
      name: 'spiritcodebind',
      component: () => import('@/views/spirit/codeBind'),
      meta: { title: '绑定口袋故事', requireAuth: true }
    },
    {
      path:'/fingerguess',
      name: 'fingerguess',
      component: ()=> import('@/views/fingerGuess'),
      meta: {title:'袋迪猜拳', requireAuth: true}
    },
    {
      path:'/knowledge',
      name: 'knowledge',
      component: ()=> import('@/views/knowledge'),
      meta: {title:'知识频道', requireAuth: false}
    },
    {
      path: '/privacyAgreement',
      name: 'privacyAgreement',
      component: () => import('@/views/privacyAgreement'),
      meta: {title:'隐私', requireAuth: false}
    },
    {
      path: '/projectionhelper',
      name: 'projectionHelper',
      component: () => import('@/views/projectionHelper/index'),
      meta: { title: '投屏助手', requireAuth: false },
    },
    {
      path: '/openmp',
      name: 'openmp',
      component: () => import('@/views/openmp/index'),
      meta: {title:'口袋故事', requireAuth: false}
    },
    ...eventRoutes,

    {
      path: '/test-wechat-pay',
      name: 'testWechatPay',
      component: () => import('@/views/test/wechatPay'),
      meta: {title:'口袋故事', requireAuth: true}
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

// caller过滤数组，命中数组中的caller不走app登录
const callerBlockList = [2015, 2016, 2017, 3015, 3016, 3017]
const callerRight = callerBlockList.some(item => +item === +store.getters.ilistenCaller)

// router hook
router.beforeEach(async (to, from, next) => {
  // console.log(to, from)
  document.title = to.meta.title ? `${to.meta.title}` : '口袋故事'

  // 设置活动对应的ilisten-title (客户端会抓取该值以替换网页标题)
  setIlistenTitle(to.meta.title || '口袋故事')

  // 检查是否在app内，如果在app内，则等待bridge就绪
  if (getCaller() !== '3003') {
    if (!window.ibridgeIsReady && browserCheck.isIlisten) {
      try {
        await bridgeHelper.bridgeSetup()
      } catch (err) {
        console.error('ibridge初始化失败或app基础信息加载失败', err)
      }
    }
  }

  /* register WxShareConfig */
  // ios微信分享，ios微信浏览器中，url不随router变化，需要在进入的url注册分享
  if (browserCheck.isWechat && browserCheck.isIphone) {
    registerWxConfig(window._iosShareUrl, { cb: () => setWxShare() })
  }

  // auto login
  let token = store.getters.token

  if (token) {
    let isTokenValid = false
    try {
      let result = await checkToken(token)
      isTokenValid = true
      store.dispatch('updateUserinfo', store.getters.token)
      // 获取v4token
      if (!store.getters.v4token) {
        let v4token = await getV4Token(store.getters.token)
        await store.dispatch('setV4token', v4token)
        await store.dispatch('getUserSubInfo')
      } else {
        store.dispatch('getUserSubInfo')
      }
    } catch (e) {
      if (e.retcode == -1) {
        store.dispatch('clearUserinfo')
        login(window.location.href)
      }
    }
  }

  if (store.getters.isIlisten && !token && to.query && to.query.authToken) {
    let authToken = to.query && to.query.authToken
    await store.dispatch('getUserinfo', authToken)
    let query = cloneDeep(to.query)
    query = omit(query, ['authToken', 'tag'])
    next({ path: to.path, query: query })
    return
  }

  // 在 url 中添加 tag 参数以标记登录等特殊行为
  const { tag } = to.query
  let query = cloneDeep(to.query)
  if (tag) {
    await beforeTagHandle(tag, to, from, next)
    query = omit(query, ['authToken', 'tag'])
    next({ path: to.path, query: query })
    return
  }
  // check auth
  if (to.meta.requireAuth && !token) {
    login(window.location.href)
    return
  }

  // app内尝试拉取app登录态
  if (store.getters.isIlisten && !token && to.query.authToken !== '' && !store.getters.haveCheckedAppAuth && !callerRight) {
    Cookies.set('haveCheckedAppAuth', '1', { expires: 1 / 24 / 60 / 60 * 15 })
    store.dispatch('setHaveCheckedAppAuth', true)
    login(window.location.href, 'anon')
    return
  }

  next()
})

router.afterEach(async (to, from) => {
  /* register WxShareConfig */
  // Android
  if (browserCheck.isWechat && !browserCheck.isIphone) {
    setTimeout(() => {
      registerWxConfig(location.href, { cb: () => setWxShare() })
    }, 1)
  }
  // access log
  sendAccessLog({
    path: to.path,
    fullPath: `${config.siteRoot}${to.fullPath}`,
    pageName: to.meta.title,
    routeName: to.name,
    userId: store.getters.userId || ''
  })
})

async function beforeTagHandle(tag, to, from, next) {
  switch (tag) {
    case 'login':
      await store.dispatch('getUserinfo', to.query.authToken)
      break
  }
}

function setIlistenTitle(title) {
  let ilistenTitle = document.getElementsByName('ilisten-title')[0]
  ilistenTitle.setAttribute('content', title)
}

export default router
